import { createSlotRecipe } from './runtime.js';

const chatMarkdownConfig = {"name":"chatMarkdown","slots":["root"]}

export const chatMarkdown = /* @__PURE__ */ createSlotRecipe(chatMarkdownConfig)